import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import StatsPage from './components/StatsPage';
import AdminPage from './components/AdminPage';
import CalendarPage from './components/CalendarPage';

function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bottom-nav">
      <div className="bottom-nav-container">
        <button
          className={`nav-item ${isActive('/') ? 'active' : ''}`}
          onClick={() => navigate('/')}
          aria-label="일정 보기"
        >
          <i className="fas fa-calendar-alt"></i>
          <span>일정</span>
        </button>
        <button
          className={`nav-item ${isActive('/players') ? 'active' : ''}`}
          onClick={() => navigate('/players')}
          aria-label="선수 통계 보기"
        >
          <i className="fas fa-users"></i>
          <span>선수</span>
        </button>
        <button
          className={`nav-item ${isActive('/matches') ? 'active' : ''}`}
          onClick={() => navigate('/matches')}
          aria-label="경기 기록 보기"
        >
          <i className="fas fa-futbol"></i>
          <span>경기</span>
        </button>
        <button
          className={`nav-item ${isActive('/donations') ? 'active' : ''}`}
          onClick={() => navigate('/donations')}
          aria-label="찬조 내역 보기"
        >
          <i className="fas fa-donate"></i>
          <span>찬조</span>
        </button>
        <button
          className={`nav-item ${isActive('/admin') ? 'active' : ''}`}
          onClick={() => navigate('/admin')}
          aria-label="관리 페이지"
        >
          <i className="fas fa-cog"></i>
          <span>관리</span>
        </button>
      </div>
    </nav>
  );
}

function MainContent() {
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  const handleHeaderClick = () => {
    navigate('/');
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1 onClick={handleHeaderClick} style={{ cursor: 'pointer' }}>동국FC since 2004</h1>
      </header>

      <main>
        <Routes>
          <Route path="/" element={<CalendarPage />} />
          <Route path="/players" element={<StatsPage activeTab="players" />} />
          <Route path="/matches" element={<StatsPage activeTab="matches" />} />
          <Route path="/donations" element={<StatsPage activeTab="donations" />} />
          <Route path="/admin" element={<AdminPage isAdmin={isAdmin} setIsAdmin={setIsAdmin} onBack={() => navigate('/')} />} />
        </Routes>
      </main>

      <BottomNav />
    </div>
  );
}

function App() {
  return (
    <Router>
      <MainContent />
    </Router>
  );
}

export default App;
